import _ from 'underscore';
import inherits from '../utils/inherits.js';

const ActionCreator = function () {};

_.extend(ActionCreator.prototype, {
  actions: {},
  serviceActions: {},
  mount(flux) {
    this._dispatcher = flux._dispatcher;
  },

  dispatchAction(...args) {
    this._dispatcher.dispatch({ actionType: args.shift(), args });
  },
});

ActionCreator.extend = function (ChildProto) {
  const ChildFn = function () {
    ActionCreator.call(this);
  };

  inherits(ChildFn, ActionCreator);
  _.extend(ChildFn.prototype, ActionCreator.prototype);

  if (ChildProto) {
    _.extend(ChildFn.prototype, ChildProto);
  }

  return ChildFn;
};

export default ActionCreator;
